<div class="container-spinner" *ngIf="show">
    <mat-spinner class="loader-page-spinner"></mat-spinner>
</div>
